export default __webpack_public_path__ + "static/media/volic3.d8b01e97.jpg";